/* Constant for saving data view */

export const SAVE_DATA_VIEW_CONSTANT =
  Number(process.env.REACT_APP_CONSTANT_ID) || 7;
export const CURRENT_VIEW_VERSION = "2.0";
